import { buildControllerRules } from "@gettactic/helpers/src/hook-form/buildControllerRules";
import { buildErrorMessageForName } from "@gettactic/helpers/src/hook-form/buildErrorMessageForName";
import React from "react";
import { FieldValues } from "react-hook-form";
import { TextInput } from "./TextInput";
import { HookFormTextInputProps } from "./TextInput.types";

/**
 * `TextInput` registered in a react-hook-form form: pass `form` and `name`. `isRequired`,
 * `minLength` and `maxLength` become validation rules, and the field's error is shown under it.
 */
export const HookFormTextInput = <T extends FieldValues>(
  props: HookFormTextInputProps<T>
): React.ReactElement => {
  const { form, name, rules, ...rest } = props;
  return (
    <TextInput
      {...form.register(
        name,
        buildControllerRules({
          form,
          name,
          rules,
          isRequired: props.isRequired
        })
      )}
      error={buildErrorMessageForName(form, name)}
      {...rest}
    />
  );
};
